module.exports = __webpack_public_path__ + "media/images/600px_Right_Banner_WithBalls-63fd3e8463468e9f62e60bc24734fbe1.png";